import { useEffect } from "react";
import type { z } from "zod";
import { ApiRequestError } from "./api";

/** Warns before leaving the page with unsaved changes. */
export function useUnsavedGuard(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return;
    const onBeforeUnload = (e: BeforeUnloadEvent) => e.preventDefault();
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [dirty]);
}

export function validationErrors(schema: z.ZodType, body: unknown): string[] {
  const result = schema.safeParse(body);
  return result.success ? [] : result.error.issues.map((i) => `${i.path.join(".") || "(root)"}: ${i.message}`);
}

export function describeError(error: unknown): { message: string; details: string[]; conflict: boolean } {
  if (error instanceof ApiRequestError) {
    if (error.code === "version_conflict") {
      return { message: "他の場所で更新されています。再読み込みしてから編集し直してください。", details: [], conflict: true };
    }
    if (error.code === "slug_taken") return { message: "この slug は既に使われています。", details: [], conflict: false };
    return { message: error.message, details: error.details, conflict: false };
  }
  return { message: (error as Error).message, details: [], conflict: false };
}
